export enum HubAlertModule {
  GENERAL_ALERT = 'generalAlert',
  HUB_ERR = 'hubGeneralError',
  FAILED_ORDER_UPDATE = 'failedOrderUpdate',
  NO_ETA_ERR = 'noEtaErr',
  CHANGE_SCREEN = 'changeScreen',
  INAPPBROWSER_ERR = 'inAppBrowserErr',
  LIST_PRINTER = 'listPrinter',
  EDIT_PRINTER = 'editPrinter',
  PRINT_ERR = 'printErr',
  PRINT_CONNECT_FAILED = 'printConnectFailed',
  PRINT_CONNECT_SUCCESS = 'printConnectSuccess',
  PRINT_PRESERVICE_ORDERS = 'printPreserviceOrders',
  PRINT_TODAY_ORDERS = 'printTodayOrders',
  FAILED_GET_DOCKET_CONFIG = 'failedDocketConfig',
  FAILED_GET_VIP_CONFIG = 'failedVIPConfig',
}
